<template>
<svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
  <g id="Group_207" data-name="Group 207" transform="translate(-292.812 -1061.745)">
    <path id="Path_78" data-name="Path 78" d="M331.543,1061.745v45.405l18.207-18.258v10.583l-21.938,22-21.938-22v-10.583l18.207,18.258v-45.405a35,35,0,1,0,7.462,0Z" fill="#f05b13"/>
  </g>
</svg>
</template>